module.exports = __webpack_public_path__ + "img/Nap.20d4448b.png";